import { z } from 'zod/v4';

export const companyLicenseFeaturesSchema = z.object({
  weather: z.boolean(),
});

export type CompanyLicenseFeatures = z.infer<
  typeof companyLicenseFeaturesSchema
>;
